<template>
    <div>
        <el-page-header @back="goBack" content="网元类型" v-if="parent"></el-page-header>
        <h3 style="margin-top: 0px;" v-else>网元类型</h3>

        <div class="divCon" v-if="parent">设备：175.102.132.82</div>

        <div class="divCon">
            <el-input placeholder="搜索" v-model="search">
                <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
        </div>

        <type-tags :tags="types" @chooseCallback="chooseCallback"/>

        <network-unit-instance-list :list="list" />
    </div>    
</template>

<script>
import TypeTags from './common/TypeTags.vue'
import NetworkUnitInstanceList from './common/NetworkUnitInstanceList.vue'
export default {
    name: 'NetworkUnitType',
    components: { TypeTags, NetworkUnitInstanceList },
    data: vm =>({
        parent: '',
        search: '',
        types: [], //类型
        list: [], //实例
        currentPage: 1,
        pageSize: 10
    }),
    created(){
        this.parent = this.$route.query.p
        this.getTypes()
    },
    computed: {
        totalElement(){
            return this.list.length
        }
    },
    methods: {
        goBack(){
            // this.$route.push(this.parent)
            this.$router.go(-1)
        },
        getTypes(arg){
            this.types = [
                {
                    name: 'Qos_20191204',
                    selected: false
                },
                {
                    name: 'AE_20191204',
                    selected: false
                },
                {
                    name: 'meetingMonitor_20191205',
                    selected: false
                },
                {
                    name: 'meetingMonitor_20191205',
                    selected: false
                },
                {
                    name: 'meetingMonitor_20191205',
                    selected: false
                }
            ]
        },
        // 根据网元类型获取网元实例
        chooseCallback(type){
            console.log(type)
            this.list = [{
                name: 'Qos_20191204_1',
                moduleNum: 1
            }]
        },
        handleSizeChange(){},
        handleCurrentChange(){},

        start(row){

        }
    }
}
</script>
<style scoped>
.divCon{
    width: 40%;
    margin: 20px 0px;
}
</style>